import {
	Alert,
	AlertDescription,
	AlertTitle,
} from '@dealstack/frontend/shared/components/Alert/Alert';
import { Button as ButtonV2 } from '@dealstack/frontend/shared/components/fundament/Button/Button.v2';
import { IconButton } from '@dealstack/frontend/shared/components/fundament/IconButton/IconButton';
import { useOutsideClick } from '@dealstack/frontend/shared/other/react/hooks/useOutsideClick';
import { em } from '@mantine/core';
import { memo, useRef } from 'react';
import styled from 'styled-components';

interface Texts {
	title: string;
	description: string;
	buttonText: string;
}

interface Props {
	className?: string;
	onClose: () => void;
	discardChange: (formType?: string) => void;
	texts: Texts;
}

const CancelConfirmationModal = ({ onClose, className, discardChange, texts }: Props) => {
	const ref = useRef<HTMLDivElement>(null);
	useOutsideClick<HTMLDivElement>(ref, onClose);
	return (
		<>
			<AlertWrapper ref={ref} className={className}>
				<Alert icon="warning-filled" state="warning" size="s" closeButton onClose={onClose}>
					<AlertTitle>{texts.title}</AlertTitle>
					<AlertDescription>{texts.description}</AlertDescription>
					<ButtonV2
						variant="secondary"
						buttonTheme="light"
						size="s"
						onClick={() => discardChange()}
					>
						{texts.buttonText}
					</ButtonV2>
				</Alert>
			</AlertWrapper>
			<OverlayDiv />
		</>
	);
};
const AlertWrapper = styled.div`
	width: ${em(800)};
	position: absolute;
	z-index: 100;
	top: ${em(70)};
	left: ${em(360)};
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
	padding: ${em(8)};
	border-radius: ${em(8)};
	${ButtonV2} {
		width: fit-content;
	}
`;
const OverlayDiv = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: ${({ theme }) => theme.v2.color.neutral[1100]};
	opacity: 0.8;
	z-index: 20;
	pointer-events: none;
`;
const Memoized = memo(CancelConfirmationModal);
const Styled = styled(Memoized)`
	${IconButton} {
		--color: ${({ theme }) => theme.v2.color.black[500]};
	}
`;

export { Styled as CancelConfirmationModal };
